import React, { act, Component } from "react";
import {
    Row,
    Col,
    Form,
    Space,
    Button,
    Select,
    Input,
    Table,
    Tooltip,
    message,
} from "antd";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

// import StudentAssignBusStore from "../store/StudentAssignBusStore";
import UsersStore from "../store/UsersStore";
import { DeleteFilled } from "@ant-design/icons";
import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";
import StudentStore from "../store/StudentStore";

class StudentAssignBus extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.UsersStore = new UsersStore();
        this.studentStore = new StudentStore(this);

        this.formRef = React.createRef();
        this.state = {
            loading: false,
            loadList: 0,
            companyId: "",
            text: "",
            buslist: [],
            openAssignForm: false,
            selectedRowKeys: [],


        };
    }
    async componentDidMount() {
        console.log("props", this.props)
        this.context.viewStateStore.setStudentTripDetails({
            companyId: this.props.companyId
        });
        this.columns1 = [
            {
                // title: "Assigned Vehicles",
                title: this.context.translate("_BUS_"),
                dataIndex: "vehicleNo",
                key: "vehicleId",
                width: 9,
            },
            {
                title: this.context.translate("_SEAT_CAPACITY_"),
                dataIndex: "capacity",
                width: 9,
            },
            {
                title: this.context.translate("_TRIP_NAME_"),
                dataIndex: "trip",
                width: 9,
            },
            {
                title: this.context.translate("_ROUTE_"),
                dataIndex: "route",
                width: 9,
            },
            {
                title: this.context.translate("_AVAILABLE_SEATS_"),
                dataIndex: "availableSeat",
                width: 9,
            }

        ];
        const vehicleId = this.props.assignedVehicleId;
        const companyId = this.props.companyId;
        const tripId = this.props.tripId;
        await this.studentStore.getVehicles(companyId, tripId);
        await this.setState({ companyId: companyId, tripId: tripId, buslist: this.studentStore.assetVehicleList });

        if (vehicleId) {
            await this.setState({ selectedRowKeys: [vehicleId] });
        }

        this.setState({ loadList: 1 });
        //, activeTab: this.props.activeTab

    }
    onStudentAssignBus = async () => {
        const data = {
            studentId: this.props.studentId,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedRowKeys.join(","),
            tripId: this.state.tripId
        }
        const response = await this.studentStore.assignBus(data);
        if (response?.success === "S") {
            message.success(response.message);
            this.props.tabChange("3");
        }


    }
    async handleChange(comp) {
        console.log("company", comp)
        const getVehicles = await this.studentStore.getVehicles(comp.value);
        console.log(getVehicles);

        await this.setState({ companyId: comp.value, buslist: this.studentStore.assetVehicleList });
        await this.setState({ loadList: 1 });
        // await this.handleSearch();
    }
    handleBackClick = () => {
        this.props.tabChange("1");
    };
    // handleNextClick = () => {

    //     this.props.tabChange("3");

    // }
    closeModal = () => {
        this.props.closeModal();
    };
    render() {

        return (

            <Row
                style={{
                    height: "100%",
                }}
            >
                <Col span={24} className="formColumnClass">
                    <Table
                        scroll={{ x: 240, y: 450 }}
                        style={{ padding: '0 5px 0 10px' }}
                        pagination={false}
                        rowKey="vehicleId"
                        columns={this.columns1}
                        dataSource={this.state.buslist || []}
                        rowSelection={{
                            columnWidth: 10,

                            selectedRowKeys: this.state.selectedRowKeys,

                            onChange: (selectedRowKeys, selectedRows) => {
                                // keep ONLY last selected
                                const lastKey = selectedRowKeys.slice(-1);
                                const lastRow = selectedRows.slice(-1);

                                this.setState({
                                    selectedRowKeys: lastKey,
                                    selectedRows: lastRow
                                });
                            }
                        }}
                    />


                    <div className="formFooter">
                        <Button
                            className="formsCancelButton"
                            onClick={() => {
                                this.closeModal();
                            }}
                        >
                            {this.context.translate(
                                "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                            )}
                        </Button>

                        <Button
                            onClick={this.handleBackClick}
                            className="formsSaveButton"
                        >
                            {this.context.translate("_BACK_")}
                        </Button>
                        <Button
                            onClick={this.onStudentAssignBus}
                            // onClick={this.handleNextClick}
                            className="formsSaveButton"
                        >
                            {this.context.translate("_NEXT_")}
                        </Button>
                        {/* <Button
                            style={{ marginInlineStart: "0px" }}
                            loading={this.state.loading}
                            onClick={this.onStudentAssignBus}
                            // htmlType="submit"
                            className="formsSaveButton"
                        >
                            {this.context.translate("_SUBMIT_")}
                        </Button> */}

                    </div>

                </Col>
            </Row>

        );
    }
}

StudentAssignBus.contextType = StoreContext;
export default observer(withRouter(StudentAssignBus));
